import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AutoUnsubscribe, getSupportEmail } from 'helpers';
import { SignupErrorType } from '../../types';

@Component({
    selector: 'fc-signup-completed',
    templateUrl: './signup-completed.component.html',
    styleUrls: ['./signup-completed.component.less'],
    standalone: false
})
@AutoUnsubscribe
export class SignupCompletedComponent {
    @Input() error: SignupErrorType = null;
    @Input() actionButtonLabel?: string = 'SIGNUP.ACCOUNT_VERIFICATION.BUTTON.LABEL';
    @Input() redirectToLogin?: boolean = false;
    @Output() actionButtonClicked = new EventEmitter<void>();

    supportEmail = getSupportEmail();

    onActionButtonClick() {
        this.actionButtonClicked.emit();
    }
}
